// <template>
//     <div class="coupon">
//         <hd title="优惠券说明"></hd>
//         <div class="coupon-box">
//             <div class="coupon-title">使用说明</div>
//             <ol class="coupon-content">
//                 <li>优惠券不可叠加使用。</li>
//                 <li>产生退款的情况下，优惠券不退回。</li>
//                 <li>每张优惠券只可使用一次。</li>
//                 <li>选择套餐的情况下，不能使用优惠券。</li>
//                 <li>长时间未支付自动扣款的订单，无法使用优惠券。</li>
//             </ol>
//         </div>
//         <div class="coupon-box">
//             <div class="coupon-title">体验券</div>
//             <ol class="coupon-content">
//                 <li>体验券仅供分时用车且消费总额大于0时使用；</li>
//                 <li>体验券可抵扣所有费用：时租费、套餐费、电费、车辆调度费。</li>
//             </ol>
//         </div>
//         <div class="coupon-box">
//             <div class="coupon-title">满减券</div>
//             <ol class="coupon-content">
//                 <li>满减券仅供分时车、共享车且时租费大于0时使用；</li>
//                 <li>满减券只能抵扣时租费，不能抵扣套餐费、电费、车辆调度费、违约金；</li>
//                 <li>满减券可通过响币兑换、新用户注册、邀请好友注册认证和充值金额获得。</li>
//             </ol>
//         </div>
//         <div class="coupon-box">
//             <div class="coupon-title">代金券</div>
//             <ol class="coupon-content">
//                 <li>代金券仅供分时车、共享车且时租费大于0时使用；</li>
//                 <li>代金券只能抵扣时租费，不能抵扣套餐费、电费、车辆调度费、违约金；</li>
//                 <li>代金券可通过做任务、开红包车、响活动兑换码活动获得。</li>
//             </ol>
//         </div>
//         <div class="coupon-box">
//             <div class="coupon-title">购车券</div>
//             <ol class="coupon-content">
//                 <li>购车券仅供成为共享车主时使用；</li>
//                 <li>购车券可通过扫描商家二维码成为共享车主获得。</li>
//             </ol>
//         </div>
//         <div class="coupon-box">
//             <div class="coupon-title">代步券</div>
//             <ol class="coupon-content">
//                 <li>代步券仅供代步车业务使用。</li>
//                 <li>代步券可以抵扣时租费、套餐费、电费，不能抵扣车辆调度费。</li>
//             </ol>
//         </div>
//
//
//     </div>
// </template>
// <script>
module.exports = {
    components: {
        'hd': require('c/near_powerstation/header.vue')
    }


    
}
// </script>
// <style lang="sass" scoped>
// .coupon{
//     width:100%;
//     min-height:100%;
//     padding:0.02rem 0.32rem 0.32rem;
//     box-sizing:border-box;
//     .coupon-box{
//         width:100%;
//         padding:0.32rem;
//         background-color:#fff;
//         box-sizing:border-box;
//         margin-top:0.213rem;
//         border-radius: 0.106rem;
//         box-shadow: 0px 0px 0px 0.02rem rgba(37,47,58,0.2);
//         .coupon-title{
//             font-size:.426667rem;
//             color: #252F3A;
//             font-weight: bold;
//         }
//         .coupon-content{
//             padding-left: 0.4rem;
//             margin-top: 0.213rem;
//             box-sizing:border-box;
//             li{
//                 font-size: 0.373rem;
//                 color: #666D75;
//                 line-height:0.64rem;
//                 list-style: decimal;
//             }
//         }
//     }
// }
// </style>
//
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/static_page/coupon.vue